export interface Achievement {
  id: string;
  title: string;
  descriptionUncleared: string;
  descriptionCleared: string;
  completed: boolean;
  progress: number;
  percent: number;
  outOf: number;
  image: string;
  undiscovered: string;
  keyword: string;
}

export const ACHIEVEMENTS: Achievement[] = [
  {
    id: "bc99a11f-621a-4525-859c-5c5282324253",
    title: "A Spectroscopic Discovery",
    descriptionUncleared: "Complete a single sample",
    descriptionCleared: "Completed a single sample",
    completed: false,
    progress: 0,
    percent: 0,
    outOf: 1,
    image: "assets/img/Badges-1Sample.svg",
    undiscovered: "assets/img/Badges-None.svg",
    keyword: "single",
  },
  {
    id: "0672b7bc-86ba-4a11-a322-8557a4a919d6",
    title: "Footsteps in the Right Direction",
    descriptionUncleared: "Complete 5 samples",
    descriptionCleared: "Completed 5 samples",
    completed: false,
    progress: 0,
    percent: 0,
    outOf: 5,
    image: "assets/img/Badges-5Samples.svg",
    undiscovered: "assets/img/Badges-None.svg",
    keyword: "five",
  },
  {
    id: "f51c9398-96ad-46e3-aca7-081afcf2a79b",
    title: "More Than a Beginner",
    descriptionUncleared: "Complete all beginner samples",
    descriptionCleared: "Completed all beginner samples",
    completed: false,
    progress: 0,
    percent: 0,
    outOf: 14,
    image: "assets/img/Badges-Beginner.svg",
    undiscovered: "assets/img/Badges-None.svg",
    keyword: "beginner",
  },
  {
    id: "ffca328b-dd3c-41f1-bf7a-e3e6b8e74833",
    title: "Compound Completionist",
    descriptionUncleared: "Complete all intermediate samples",
    descriptionCleared: "Completed all intermediate samples",
    completed: false,
    progress: 0,
    percent: 0,
    outOf: 9,
    image: "assets/img/Badges-Intermediate.svg",
    undiscovered: "assets/img/Badges-None.svg",
    keyword: "intermediate",
  },
];
